import { createChildBridge, resolveParentOrigin } from "./child";

/**
 * Wire the in-iframe resize bridge at app bootstrap: capture the embedding origin from the referrer,
 * post `ready` + `resize` to it, and keep the frame sized via a ResizeObserver on the document root.
 * On the standalone (non-framed) page this is a no-op (the bridge returns a no-op implementation).
 */
export function startEmbedBridge(): () => void {
  if (typeof window === "undefined" || typeof document === "undefined") return () => {};
  const bridge = createChildBridge({
    win: window,
    parentOrigin: resolveParentOrigin(document.referrer),
  });
  bridge.observe(document.documentElement);
  return () => bridge.stop();
}
